import getEwsRequestDateString from 'owa-mail-store/lib/services/utils/getEwsRequestDateString';
import getServiceContextFolderId from 'owa-mail-store/lib/services/utils/getServiceContextFolderId';
import ApplyConversationActionContext from 'owa-mail-store/lib/store/schema/ApplyConversationActionContext';
import ApplyConversationActionRequest from 'owa-service/lib/contract/ApplyConversationActionRequest';
import ApplyConversationActionResponseMessage from 'owa-service/lib/contract/ApplyConversationActionResponseMessage';
import ConversationAction from 'owa-service/lib/contract/ConversationAction';
import TargetFolderId from 'owa-service/lib/contract/TargetFolderId';
import applyConversationActionRequest from 'owa-service/lib/factory/applyConversationActionRequest';
import conversationAction from 'owa-service/lib/factory/conversationAction';
import itemId from 'owa-service/lib/factory/itemId';
import applyConversationActionService from 'owa-mail-store/lib/services/applyConversationActionService';
import RequestOptions from 'owa-service/lib/RequestOptions';

function createConversationAction(
    conversationContext: ApplyConversationActionContext,
    isReadValue: boolean,
    targetFolderId: TargetFolderId
): ConversationAction {
    return conversationAction({
        Action: 'SetReadState',
        ConversationId: itemId({ Id: conversationContext.conversationId }),
        IsRead: isReadValue,
        ConversationLastSyncTime: getEwsRequestDateString(
            conversationContext.conversationLastSyncTimeStamp
        ),
        SuppressReadReceipts: true,
        ContextFolderId: targetFolderId,
    });
}

function configureRequestBody(
    conversationContexts: ApplyConversationActionContext[],
    isReadValue: boolean,
    contextFolderId: string
): ApplyConversationActionRequest {
    const targetFolderId = getServiceContextFolderId(contextFolderId);

    const conversationActions = conversationContexts.map(conversationContext =>
        createConversationAction(conversationContext, isReadValue, targetFolderId)
    );

    return applyConversationActionRequest({
        ConversationActions: conversationActions,
        ReturnMovedItemIds: false,
    });
}

/**
 * Marks conversations as read/unread
 * @param conversationContexts Context about the conversations to be updated
 * @param isReadValue read/unread boolean state
 * @param contextFolderId the context for which the read/unread is being applied (only items of the conversation in this folder are changing read/unread state)
 * @param requestOptions request options to be passed in
 */
export default function markConversationsAsReadService(
    conversationContexts: ApplyConversationActionContext[],
    isReadValue: boolean,
    contextFolderId: string,
    requestOptions?: RequestOptions
): Promise<ApplyConversationActionResponseMessage> {
    const requestBody = configureRequestBody(conversationContexts, isReadValue, contextFolderId);
    return applyConversationActionService(
        requestBody,
        undefined /* Use default JsonRequestHeader */,
        requestOptions
    );
}
